module.exports = __webpack_public_path__ + "media/src/assets/Images/RadioButton-a2547d33ab8cfcc9fa358c268d68594f.svg";